export enum Sites {
  AllSites = 'zByl',
  SiteId = 'ywEf',
  SiteName = 'D3nx',
  Pleaseselectasite = 'rxJh',
  FromPrimaryWarehouseBrackets = '09dd',
  FromSiteColonAndSpace = 'fyh5',
  ToSiteColonAndSpace = 'NJhk',
}
